const translation = {
	PageSize: 'Taille de page',
	PageOrientation: 'Orientation de la page',
	Format: 'Format',
	DPI: 'DPI',
	Generate: 'Générer'
};

export default translation;
